import { defineSlotRecipe } from '@chakra-ui/react';
import { listAnatomy } from '@chakra-ui/react/anatomy';

export const listRecipe = defineSlotRecipe({
  className: 'ac-list',
  slots: listAnatomy.keys(),
  base: {
    root: {
      '& &': {
        paddingLeft: '30px',
      },
    },
    item: {
      '& + &': {
        marginTop: '4px',
      },
    },
  },
});
